import './Portfolio.css';

import { useTranslation } from 'react-i18next';

import portfolioData from '../../data/portfolioData';

function Portfolio() {

  const { t } = useTranslation();

  return (

    <section className="portfolio" id="portfolio">

      <div className="portfolio-container">

        <div className="portfolio-header">

          <p className="section-label">
            {t('portfolio.label')}
          </p>

          <h2>
            {t('portfolio.title')}
          </h2>

        </div>

        <div className="portfolio-grid">

          {portfolioData.map((project) => (

            <article
              className="portfolio-card"
              key={project.title}
            >

              <div className="portfolio-image">

                Image

              </div>

              <div className="portfolio-content">

                <span>
                  {project.category}
                </span>

                <h3>
                  {project.title}
                </h3>

                <p>
                  {project.description}
                </p>

              </div>

            </article>

          ))}

        </div>

      </div>

    </section>

  );

}

export default Portfolio;